import React, { useEffect, useState, useContext } from 'react';
import { useMediaQuery } from '@mui/material';
import LayoutDesktop from './LayoutDesktop';
import LayoutMobile from './LayoutMobile';
import { getUserInfo } from '../apiCalls/user_profile/api_v1_profile';
import PollDialog from '../components/PollDialog';
import { AuthContext } from '../apiCalls/jwt/AuthContext';
import { getActivePolls } from '../apiCalls/feedback/feedback';

const Layout = ({ children }) => {
  const isDesktop = useMediaQuery('(min-width:900px)');
  const [showPollDialog, setShowPollDialog] = useState(false);
  const { auth } = useContext(AuthContext);
  
  useEffect(() => {
    const fetchUserInfo = async () => {
      try {
        const response = await getUserInfo();
        if (response.status === 200) {
          sessionStorage.setItem('skillLevel', response.data.skill_level.toLowerCase());
          sessionStorage.setItem('last_played_level', response.data.latest_played_level);
        }
      } catch (error) {
        sessionStorage.setItem('skillLevel', 'beginner');
      }
    };
    
    const hasReloaded = sessionStorage.getItem('hasReloaded');
    if (!hasReloaded) {
      sessionStorage.setItem('hasReloaded', 'true');
      window.location.reload();
      return;
    }

    const checkAndShowPoll = async () => {
      const token = auth.accessToken || sessionStorage.getItem('accessToken');
      const pollAlreadyShown = sessionStorage.getItem('pollShown');
      
      if (token && !pollAlreadyShown) {
        try {
          const response = await getActivePolls();
          if (response.data.success && response.data.polls.length > 0) {
            const availablePolls = response.data.polls.filter(poll => !poll.has_submitted);
            if (availablePolls.length > 0) {
              setTimeout(() => {
                setShowPollDialog(true);
                // Mark as shown immediately when dialog appears
                sessionStorage.setItem('pollShown', 'true');
              }, 1000);
            }
          }
        } catch (error) {
          console.error('Error checking for available polls:', error);
        }
      }
    };
    
    if (auth.accessToken) {
      fetchUserInfo();
      checkAndShowPoll();
    }
  }, [auth.accessToken]);

  return (
    <>
      {isDesktop ? (
        <LayoutDesktop>{children}</LayoutDesktop>
      ) : (
        <LayoutMobile>{children}</LayoutMobile>
      )}
      <PollDialog 
        open={showPollDialog} 
        onClose={() => setShowPollDialog(false)} 
      />
    </>
  );
};

export default Layout;